module.exports = __webpack_public_path__ + "img/blue_logo.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/blue_logo.jpg
 ** module id = 1251
 ** module chunks = 0
 **/